import { optimizerServiceManager, type DashboardRule } from '@/optimizer';
import { OPTIMIZER_PLAN_TIMEOUT_MS, withOptimizerTimeout } from '@/optimizer/helpers/withOptimizerTimeout';
import { lockedVariables } from '@/dashboards/shared/optimisation/optimiserRun';
import type { OptimisationInputs, OptimizedPlan } from '@/dashboards/shared/optimisation/optimisationSession';

const appliesToCampaign = (rule: DashboardRule) => rule.target === 'all' || rule.target === 'campaign';

export const runCampaignOptimisation = async ({
    inputs,
    rules,
}: {
    inputs: OptimisationInputs;
    rules: DashboardRule[];
}): Promise<OptimizedPlan> => {
    if (!optimizerServiceManager) {
        throw new Error('Optimizer is not initialized');
    }

    return withOptimizerTimeout(
        optimizerServiceManager.serviceManager.getOptimizedPlan({
            budget: inputs.budget,
            optimizationBase: inputs.optimizationBase,
            startDate: inputs.startDate,
            endDate: inputs.endDate,
            variables: lockedVariables(inputs),
            configRules: rules.filter(appliesToCampaign),
        }),
        'Campaign budget optimization',
        OPTIMIZER_PLAN_TIMEOUT_MS,
    );
};
